import React, { useState, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import EyeIcon from "mdi-material-ui/EyeCircle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

import { isUserRole } from "../../utils/user";
import ClientsTable from "../../components/Tables/Clients";
import CreateClientStepper from "../../components/Dialogs/CreateClientStepper";
import ClientDetailsDialog from "../../components/Dialogs/ClientDetails";

const ClientsContent = () => {
  const [data, setData] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const classes = useStyles();
  const clients = useSelector((state) => state.clients.entities);

  useEffect(() => {
    const tempData = [];
    Object.values(clients).forEach((client) => {
      if (client.isDeleted) return;
      tempData.push({
        name: `${client.firstName} ${client.lastName}`,
        email: client.email,
        numProperties: client.propertyIds.length,
        actions: actions(client.id),
        isArchived: client.isArchived ? "Yes" : "No",
        id: client.id,
      });
    });
    setData(tempData);
  }, [clients]);

  const actions = (id) => {
    return (
      <span className={classes.actions}>
        <IconButton onClick={() => setSelectedClient(id)}>
          <EyeIcon />
        </IconButton>
      </span>
    );
  };

  const isAdmin = isUserRole({ admin: true });

  return (
    <div className={classes.root}>
      <div className={classes.scrollable}>
        <Paper className={classes.paper}>
          <List>
            <ListItem>
              <ListItemText primary="Clients" />
              {isAdmin && (
                <ListItemSecondaryAction>
                  <Button
                    onClick={() => setShowCreateModal(true)}
                    color="primary"
                    variant="contained"
                  >
                    Create
                  </Button>
                </ListItemSecondaryAction>
              )}
            </ListItem>
            <ListItem>
              <ClientsTable data={data} />
            </ListItem>
          </List>
        </Paper>
      </div>
      {showCreateModal && (
        <CreateClientStepper
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
        />
      )}
      {selectedClient && (
        <ClientDetailsDialog
          id={selectedClient}
          isOpen={Boolean(selectedClient)}
          onClose={() => setSelectedClient(null)}
        />
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    position: "relative",
  },
  scrollable: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflowX: "hidden",
    overflowY: "auto",
  },
  exportContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  link: {
    color: theme.palette.common.white,
    textDecoration: "none",
  },
  paper: {
    margin: theme.spacing(3),
    padding: theme.spacing(3),
  },
  buttonContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
}));

export default ClientsContent;
